<template>
    <div class="col dashboard__dates">
        <div class="box box--gray" v-bind:class="{pending: pending}">
            <div class="row">
                <div class="col-lg-4">
                    <h2 class="h h--2 dashboard__dates-h2">Wydarzenia stacjonarne</h2>
                    <router-link :to="{name: 'StationaryTraining'}" class="button button--small button--fixed-width">Zobacz listę &raquo;</router-link>
                </div>
                <div class="col-lg-8">
                    <h3 class="dashboard__dates-subheader">Sprawdź nadchodzące wydarzenia i zapisz się za pomocą jednego kliknięcia.</h3>
                    <table class="nearest-dates">
                        <tr v-if="events" v-for="event in events" :key="event.id">
                            <td>&raquo;</td>
                            <td>{{ event.start_time | formatDate("DD.MM.YYYY") }}</td>
                            <td><router-link :to="{name: 'Training', params: { id: event.id }}" class="nearest-dates__link">{{ event.event_type.name }} / <b>{{ event.title }}</b></router-link></td>
                        </tr>
                        <tr v-if="!events.length">
                            <td>Brak najbliższych wydarzeń</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'CalendarWidget',
  data () {
    return {
      pending: true,
      events: []
    }
  },
  created() {
    let vm = this;

    Vue.axios({
      method: 'get',
      url: '/events',
      params: {
        pagination: 2,
        from_start_date: new Date()
      }
    })
    .then(response => {
      vm.pending = false
      vm.events = response.data.data.events
    })
    .catch(error => {
      vm.pending = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/calendar/CalendarWidget.vue